import { z } from "zod";
/**
 * Platform frontend builds: the control plane asks the Agent service, which
 * asks the launcher, to run `npm ci` and one npm script over a draft's source
 * in a short-lived sandbox, and returns the built output directory.
 */
export const FRONTEND_BUILD_MAX_SOURCE_BYTES = 50 * 1024 * 1024;
export const FRONTEND_BUILD_MAX_OUTPUT_BYTES = 50 * 1024 * 1024;
export const FRONTEND_BUILD_MAX_LOG_BYTES = 16 * 1024;
const base64Bounded = (bytes) => z.string().max(Math.ceil(bytes / 3) * 4).regex(/^[A-Za-z0-9+/]*={0,2}$/);
export const frontendBuildScriptSchema = z
    .string()
    .regex(/^[A-Za-z0-9][A-Za-z0-9:._-]{0,63}$/);
/** A relative directory inside the app: no absolute, empty, dot or parent segments. */
export const frontendBuildOutputDirectorySchema = z
    .string()
    .min(1)
    .max(255)
    .refine((value) => !value.startsWith("/") &&
    !value.includes("\\") &&
    value
        .split("/")
        .every((segment) => segment.length > 0 && segment !== "." && segment !== ".." && /^[A-Za-z0-9._@+-]+$/.test(segment)), "Output directory must be a relative path inside the app");
export const frontendBuildRequestSchema = z
    .object({
    schemaVersion: z.literal(1),
    buildId: z.uuid(),
    appId: z.uuid(),
    script: frontendBuildScriptSchema,
    outputDirectory: frontendBuildOutputDirectorySchema,
    /** gzip tar of the app's source tree, relative to the app root. */
    sourceArchiveBase64: base64Bounded(FRONTEND_BUILD_MAX_SOURCE_BYTES),
})
    .strict();
export const frontendBuildResultSchema = z.discriminatedUnion("state", [
    z
        .object({
        schemaVersion: z.literal(1),
        buildId: z.uuid(),
        state: z.literal("succeeded"),
        durationMs: z.number().int().nonnegative(),
        log: z.string().max(FRONTEND_BUILD_MAX_LOG_BYTES),
        /** gzip tar of the output directory's contents, relative to it. */
        outputArchiveBase64: base64Bounded(FRONTEND_BUILD_MAX_OUTPUT_BYTES),
    })
        .strict(),
    z
        .object({
        schemaVersion: z.literal(1),
        buildId: z.uuid(),
        state: z.literal("failed"),
        reason: z.enum(["build_failed", "output_missing", "output_invalid", "output_too_large", "timed_out"]),
        exitCode: z.number().int().nullable(),
        durationMs: z.number().int().nonnegative(),
        log: z.string().max(FRONTEND_BUILD_MAX_LOG_BYTES),
    })
        .strict(),
]);
/** Removing a deleted app's npm cache; `removed` is false when it had none. */
export const frontendBuildCacheRetireResultSchema = z
    .object({ schemaVersion: z.literal(1), appId: z.uuid(), removed: z.boolean() })
    .strict();
//# sourceMappingURL=frontend-builds.js.map